var _style, _path, _rect, _rect2, _path2, _path3, _rect3, _path4, _polygon, _path5, _path6, _polygon2, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoUnifiedSmbWit(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Laag_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 300 200",
    style: {
      enableBackground: "new 0 0 300 300"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF;}\r\n\t.st1{fill:#FFFFFF;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M74.97,128.74c-5.72,0-8.85,2.08-10.75,4.68v-3.9h-9.11v43.37h9.28v-26.19c0-5.81,3.21-9.71,8.93-9.71 c4.77,0,8.24,2.17,8.24,9.8v26.11h9.19v-27.15C90.75,133.25,83.9,128.74,74.97,128.74"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 99.8,
    y: 129.52,
    className: "st0",
    width: 9.28,
    height: 43.37
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 145.96,
    y: 113.04,
    className: "st0",
    width: 10.15,
    height: 9.45
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M146.39,129.52h-16.4v-0.95c0-5.03,0.78-7.2,5.64-7.2h2v-8.33h-2.69c-10.41,0-14.14,3.56-14.14,13.79v2.69 h-5.55v7.98h5.55v35.39h9.19V137.5h16.4v35.39h9.28v-43.37h-7.96H146.39z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M172.41,146.34c0.43-5.9,2.95-9.54,8.33-9.54c5.29,0,7.89,3.21,8.24,9.54H172.41z M180.74,128.74 c-11.36,0-17.61,6.68-17.61,19.43v5.9c0,11.53,6.59,19.6,18.99,19.6c7.63,0,12.49-2.08,15.53-7.37l-6.94-4.86 c-1.73,2.69-3.82,4.25-8.94,4.25c-6.85,0-9.45-5.29-9.45-12.06v-0.17h25.93v-4.77C198.26,135.85,192.62,128.74,180.74,128.74"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 99.36,
    y: 113.04,
    className: "st0",
    width: 10.15,
    height: 9.45
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M241.1,153.54v-40.5h-9.19v19.52c-2.43-2.52-5.9-3.82-10.41-3.82c-10.5,0-17.26,6.94-17.26,19.43v5.9 c0,11.36,5.72,19.6,17.26,19.6c4.77,0,8.07-1.39,10.41-3.82v3.03h9.19v-15.01h-9.56c-0.87,4.61-3.43,7.81-8.82,7.81 c-6.68,0-9.28-5.29-9.28-12.06v-5.03c0-7.54,3.03-11.8,9.28-11.8c5.98,0,9.19,4.16,9.19,11.28v5.46H241.1z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "20.09,129.52 10.81,129.52 5.26,129.52 5.26,137.5 10.81,137.5 10.81,153.54 20.1,153.54 20.1,129.52  "
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M37.27,155.71c0,5.98-3.12,9.8-8.85,9.8c-4.34,0-7.57-1.75-8.2-7.64h-9.36c0.47,11.5,7.21,15.79,15.83,15.79 c6.07,0,8.67-1.56,10.67-4.69v3.9h9.11v-43.37h-9.19V155.71z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M262.58,147.6c-0.56-0.96-1.27-1.32-2.57-1.32c-1.15,0-1.65,0.52-1.65,1.25c0,0.86,0.75,1.34,2.57,1.86 c3.13,0.9,4.32,2.07,4.32,4.53c0,2.61-1.75,4.3-5.03,4.3c-2.63,0-4.41-0.65-5.76-2.36l2.59-1.82c0.71,0.9,1.59,1.3,2.88,1.3 c1.34,0,1.86-0.56,1.86-1.25c0-0.84-0.58-1.25-2.71-1.94c-2.92-0.94-4.18-2.28-4.18-4.59c0-2.38,1.57-4.16,5.08-4.16 c2.3,0,4.16,0.77,5.18,2.36L262.58,147.6z"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "274.22,150.92 278.11,143.61 281.34,143.61 281.34,158.02 278.08,158.02 278.08,149.87 275.12,155.64  273.26,155.64 270.36,149.93 270.36,158.02 267.1,158.02 267.1,143.61 270.32,143.61 "
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M287.33,155.13h1.65c1.55,0,2.3-0.52,2.3-1.59c0-1.17-0.79-1.57-2.55-1.57h-1.4V155.13z M287.33,149.1h1.46 c1.4,0,2.03-0.44,2.03-1.27c0-0.86-0.44-1.36-2.34-1.36h-1.15V149.1z M288.9,143.61c3.4,0,5.39,1.19,5.39,3.82 c0,1.48-0.65,2.34-1.65,3.01c1.32,0.65,2.11,1.67,2.11,3.45c0,2.3-1.55,4.13-5.39,4.13h-5.49v-14.41H288.9z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoUnifiedSmbWit);
export default __webpack_public_path__ + "static/media/Logo Unified SMB - Wit.d3f74b381917b15c3b01f9962efc2fd7.svg";
export { ForwardRef as ReactComponent };